export const GET_TRANSACTION_STATUS_REQUEST = '@@toyota/GET_TRANSACTION_STATUS_REQUEST';
export const GET_TRANSACTION_STATUS_SUCCESS = '@@toyota/GET_TRANSACTION_STATUS_SUCCESS';
export const GET_TRANSACTION_STATUS_FAILED = '@@toyota/GET_TRANSACTION_STATUS_FAILED';
export const LOAD_JAPAN_PART_MASTER_REQUEST = '@@toyota/LOAD_JAPAN_PART_MASTER_REQUEST';
export const LOAD_JAPAN_PART_MASTER_SUCCESS = '@@toyota/LOAD_JAPAN_PART_MASTER_SUCCESS';
export const LOAD_JAPAN_PART_MASTER_FAILED = '@@toyota/LOAD_JAPAN_PART_MASTER_FAILED';
export const LOAD_EXTRA_PARTS_LIST_REQUEST = '@@toyota/LOAD_EXTRA_PARTS_LIST_REQUEST';
export const LOAD_EXTRA_PARTS_LIST_SUCCESS = '@@toyota/LOAD_EXTRA_PARTS_LIST_SUCCESS';
export const LOAD_EXTRA_PARTS_LIST_FAILED = '@@toyota/LOAD_EXTRA_PARTS_LIST_FAILED';
export const GET_BACKUP_RECORDS_REQUEST = '@@toyota/GET_BACKUP_RECORDS_REQUEST';
export const GET_BACKUP_RECORDS_SUCCESS = '@@toyota/GET_BACKUP_RECORDS_SUCCESS';
export const GET_BACKUP_RECORDS_FAILED = '@@toyota/GET_BACKUP_RECORDS_FAILED';
export const GET_SAVED_RECORDS_REQUEST = '@@toyota/GET_SAVED_RECORDS_REQUEST';
export const GET_SAVED_RECORDS_SUCCESS = '@@toyota/GET_SAVED_RECORDS_SUCCESS';
export const GET_SAVED_RECORDS_FAILED = '@@toyota/GET_SAVED_RECORDS_FAILED';
export const CLEAR_LOADING_STATUS = '@@toyota/CLEAR_LOADING_STATUS';
export const SELECT_PARTS_LIST_ORIGIN = '@@toyota/SELECT_PARTS_LIST_ORIGIN';
export const SAVE_PARTS_PRICE_CHANGE = '@@toyota/SAVE_PARTS_PRICE_CHANGE';
export const SAVE_PARTS_PRICE_FAILED = '@@toyota/SAVE_PARTS_PRICE_FAILED';
export const SAVE_PARTS_PRICE_SUCCESS = '@@toyota/SAVE_PARTS_PRICE_SUCCESS';
export const GET_PRICE_CHANGE_STATUS_REQUEST = '@@toyota/GET_PRICE_CHANGE_STATUS_REQUEST';
export const GET_PRICE_CHANGE_STATUS_SUCCESS = '@@toyota/GET_PRICE_CHANGE_STATUS_SUCCESS';
export const GET_PRICE_CHANGE_STATUS_FAILED = '@@toyota/GET_PRICE_CHANGE_STATUS_FAILED';
